import angular from 'angular';
import uiRouter from 'angular-ui-router';

import CheckinSettingsComponent from './settings.component';

const checkinSettingsModule = angular.module('tinaba.components.checkin.settings', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('checkin.settings', {
    url: '/settings',
    template: '<checkin-settings></checkin-settings>'
  });
})

.component('checkinSettings', CheckinSettingsComponent);

export default checkinSettingsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/checkin/settings/settings.js
 **/